import { render, staticRenderFns } from "./recurring-reminders-container.vue?vue&type=template&id=cbc2947c"
import script from "./recurring-reminders-container.vue?vue&type=script&lang=js"
export * from "./recurring-reminders-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports